<template>
  <v-card-text class="pt-8">
    <v-row>
      <v-col>
        <TibBannerTimeInput :readonly="readonly" />
        <TibBannerTitleInput :readonly="readonly" />

        <TibBannerTrainInput :readonly="readonly" />

        <TibBannerReasonInput :readonly="readonly" />
        <TibBannerTextInput :readonly="readonly" />
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import TibBannerTitleInput from './TibBannerTitleInput'
import TibBannerTimeInput from './TibBannerTimeInput'
import TibBannerTextInput from './TibBannerTextInput'
import TibBannerTrainInput from './TibBannerTrainInput'
import TibBannerReasonInput from './TibBannerReasonInput'
export default {
  name: 'TibBannerForm',

  props: {
    readonly: Boolean
  },

  components: {
    TibBannerTitleInput,
    TibBannerTimeInput,
    TibBannerTextInput,
    TibBannerTrainInput,
    TibBannerReasonInput
  }
}
</script>
